import { render, staticRenderFns } from "./Vireed.vue?vue&type=template&id=6fced8aa&scoped=true&"
import script from "./Vireed.vue?vue&type=script&lang=js&"
export * from "./Vireed.vue?vue&type=script&lang=js&"
import style0 from "./Vireed.vue?vue&type=style&index=0&id=6fced8aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fced8aa",
  null
  
)

export default component.exports